import { useMutation, useQuery } from '@tanstack/react-query';
import {
  App,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Flex,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Table,
} from 'antd';
import React, { useState } from 'react';
import Heading from '../../components/common/Heading/Heading';
import { queryKeys } from '../../services/react-query/queryKeys';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { getAccountsReceivableSummary } from '../../network/generaledgerReport';
import { getParties } from '../../network/PaymentEntry';
import DashboardCards from '../Dashboard/DashboardCards';
const { RangePicker } = DatePicker;
const AccountReceivableSummary = ({ t }) => {
  const { currentLang, companyName } = useSelector((state) => state.user);
  const [form] = Form.useForm();
  const [sourceData, setSourceData] = useState({
    report_date: dayjs().format('YYYY-MM-DD'),
    party: '',
  });

  const { data: stockBalanceDetails, isLoading } = useQuery({
    queryKey: [
      queryKeys.getAccountsReceivableSummary,
      companyName,
      currentLang,
      sourceData.party,
      sourceData.report_date,
    ],
    queryFn: () =>
      getAccountsReceivableSummary({
        currentLang,
        companyName,
        party: sourceData.party,
        report_date: sourceData.report_date,
      }),
  });
  const { mutate: onAddPaymentEntry, data: partiesData } = useMutation({
    mutationKey: [queryKeys.getParties],
    mutationFn: (id) => getParties(id),
  });
  const columns = stockBalanceDetails?.message?.columns?.map((col) => ({
    title: col?.label,
    dataIndex: col?.fieldname,
    key: col?.fieldname,
    // width: col.width,
  }));

  const dataSource = stockBalanceDetails?.message?.result?.map(
    (item, index) => ({
      key: index,
      ...item,
      date: dayjs(item.date).format('YYYY-MM-DD'),
      posting_time: dayjs(item.posting_time).format('HH:mm'),
    })
  );
  // const totalRow = stockBalanceDetails?.message?.result?.slice(-1)[0];

  return (
    <div className="stock-balance-report">
      {/* <Heading title={t.reports} subTitle={t.accountReceivable} path="/" /> */}
      <DashboardCards t={t} />
      <Card className="card_custom">
        <Form name="basic" layout="vertical" form={form}>
          <Row gutter={[16, 0]}>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="date"
                // label={t.date}
                initialValue={dayjs()}
              >
                <DatePicker
                  format="YYYY/MM/DD"
                  style={{ width: '100%' }}
                  defaultValue={dayjs()}
                  onChange={(dates, dateStrings) => {
                    setSourceData({
                      ...sourceData,
                      report_date: dateStrings,
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="party_type"
                // label={t.PartyType}
              >
                <Select
                  placeholder={t.PartyType}
                  allowClear
                  onClear={() => {
                    setSourceData({
                      ...sourceData,
                      party_type: '',
                    });
                  }}
                  onChange={(value) => {
                    onAddPaymentEntry(value);
                  }}
                  options={[
                    { value: 'Customer', label: t.Customer },
                    { value: 'Supplier', label: t.Supplier },
                    { value: 'Employee', label: t.Employee },
                    { value: 'Shareholder', label: t.Shareholder },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12} xl={8} xxl={8}>
              <Form.Item
                name="Party"
                // label={t.Party}
              >
                <Select
                  placeholder={t.Party}
                  allowClear
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  onChange={(value) => {
                    setSourceData({
                      ...sourceData,
                      party: `${value === undefined ? '[]' : `["${value}"]`}`,
                    });
                  }}
                  options={partiesData?.message?.parties?.map((user) => ({
                    value: user?.name,
                    label: user?.name,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <Divider orientation="left">{t.accountReceivable}</Divider>
        <Table
          className="table_custom"
          columns={columns}
          dataSource={dataSource}
          loading={isLoading}
          pagination={{ hideOnSinglePage: true }}
          rowKey="key"
          scroll={{ x: 'max-content' }}
        />
      </Card>
    </div>
  );
};

export default AccountReceivableSummary;
